import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const CompaniesTableCard = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(280px, 350px) auto;
  grid-template-rows: auto auto;
  align-items: center;
  column-gap: 16px;
  row-gap: 12px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 32px;
  padding: 20px 12px 12px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);

  > .companies-toolbar {
    grid-column: 3;
    grid-row: 1;
    width: 100%;
  }

  > .companies-management-table {
    grid-column: 1 / -1;
    grid-row: 2;
  }

  @media (max-width: 1200px) {
    grid-template-columns: minmax(0, 1fr) auto;

    > .companies-toolbar {
      grid-column: 1 / -1;
      grid-row: 2;
    }

    > .companies-management-table {
      grid-row: 4;
    }
  }
`

export const CompaniesTableHeader = styled.div`
  display: contents;

  > a {
    grid-column: 4;
    grid-row: 1;
    display: flex;

    button {
      margin: 0;
    }
  }

  @media (max-width: 1200px) {
    > a {
      grid-column: 2;
    }
  }
`

export const CompaniesTableTitle = styled.h2`
  grid-column: 1;
  grid-row: 1;
  margin: 0;
  color: #1f344d;
  font-family: 'Public Sans', sans-serif;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.2;
`

export const CompaniesFilter = styled.div`
  grid-column: 2;
  grid-row: 1;
  display: flex;
  align-items: center;
  min-height: 48px;

  button {
    margin: 0;
  }

  @media (max-width: 1200px) {
    grid-column: 1 / -1;
    grid-row: 3;
  }
`

// ACTIONS

export const ContainerActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  gap: 24px;
  width: 100%;
  padding: 0;

  button {
    height: 48px;
    min-height: 48px;
    margin: 0;
    white-space: nowrap;
  }
`

export const TextViewMore = styled.p`
  // public sans font
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #c6016b;
  cursor: pointer;
`

export const EditContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

export const TextEdit = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #2d749c;
  cursor: pointer;
  margin-right: 10px;
  margin-left: 10px;
`

export const CheckContainer = styled.div<{ check: boolean; activeColumn?: boolean }>`
  display: flex;
  height: 25px;
  width: 25px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  border: ${(props) => (props.check ? '1px solid #449f0f' : '1px solid #C2C2C2')};
  color: ${(props) => (props.check ? '#449f0f' : '#C2C2C2')};
  background-color: #fff;
`
